import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const RejectIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M5.68014 7.09436C4.62708 8.44904 4 10.1513 4 12C4 16.4182 7.58172 20 12 20C13.8487 20 15.5509 19.3729 16.9056 18.3198L5.68014 7.09436ZM7.09436 5.68014L18.3198 16.9056C19.3729 15.5509 20 13.8487 20 12C20 7.58172 16.4182 4 12 4C10.1513 4 8.44904 4.62708 7.09436 5.68014ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

RejectIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(RejectIcon);
